import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';

@Component({
  selector: 'app-pg-response',
  templateUrl: './pg-response.component.html',
  styleUrls: ['./pg-response.component.scss']
})
export class PGResponseComponent implements OnInit {
  statusCode: string = "";
  message: string = "";
  txnId: string = "";

  constructor(
    private EncrdecrService: EncrdecrService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.statusCode = this.EncrdecrService.getDecr(params.get('statuscode'));
      this.message = this.EncrdecrService.getDecr(params.get('message'));
      this.txnId = this.EncrdecrService.getDecr(params.get('txnid'));
    });
  }

  // Atom doesn't give us a clean boolean, so infer success/failure from the message text
  // rather than guessing at statusCode value semantics.
  get isSuccess(): boolean {
    return (this.message || '').toLowerCase().includes('success');
  }

  get isFailed(): boolean {
    const m = (this.message || '').toLowerCase();
    return m.includes('fail') || m.includes('declin') || m.includes('error') || m.includes('invalid');
  }
}
